import { render } from "./IndicatorsB2C.vue?vue&type=template&id=51d8fba1&scoped=true"
import script from "./IndicatorsB2C.vue?vue&type=script&lang=js"
export * from "./IndicatorsB2C.vue?vue&type=script&lang=js"

import "./IndicatorsB2C.vue?vue&type=style&index=0&id=51d8fba1&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d8fba1"]])

export default __exports__